/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiAEjectIcon16Light = forwardRef('MediaUiAEjectIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.015 2.468a1.3 1.3 0 0 0-2.03 0L2.259 8.375A1 1 0 0 0 3.04 10h9.92a1 1 0 0 0 .78-1.625L9.016 2.468Zm-1.25.625a.3.3 0 0 1 .47 0L12.96 9H3.04l4.726-5.907Z" }),
        React.createElement("path", { d: "M2.5 13h11a.5.5 0 0 0 0-1h-11a.5.5 0 1 0 0 1Z" })));
});
